(() => {
  const SCRIPT = document.currentScript;
  if (!SCRIPT) return;

  // --- Config from loader tag ---
  const cfg = {
    cssUrl      : (SCRIPT.dataset.gbmCss      || '').trim(),
    localMapUrl : (SCRIPT.dataset.gbmLocalmap || '').trim(),
    localUrl    : (SCRIPT.dataset.gbmLocalUrl || '').trim(),
    shipUrl     : (SCRIPT.dataset.gbmShipUrl  || '').trim(),
    mode        : (SCRIPT.dataset.gbmMode     || 'redirect').trim(), // 'prompt-local' (test) or 'redirect' (prod)
    allowHosts  : (SCRIPT.dataset.gbmAllowHosts || '').split(',').map(s => s.trim()).filter(Boolean),
    enableParam : (SCRIPT.dataset.gbmEnableParam || 'gate').trim()
  };

  // --- Load dedicated CSS (modal styles) ---
  if (cfg.cssUrl) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = cfg.cssUrl;
    document.head.appendChild(link);
  }

  // --- Feature flags: only run in sandbox/testing contexts ---
  const hasParam  = new URLSearchParams(location.search).has(cfg.enableParam);
  const hasCookie = document.cookie.split('; ').some(c => c.trim().startsWith('gbm_gate_test=1'));
  const isPreview = /preview_theme_id=/.test(location.search); // Shopify theme previews
  const isAllowed = cfg.allowHosts.includes(location.hostname);
  const GATE_ON   = hasParam || hasCookie || isPreview || isAllowed;
  if (!GATE_ON) return;

  // --- Keys/helpers ---
  const LS_MARKET  = 'gbm_market';         // 'local' | 'ship'
  const SS_CHECKED = 'gbm_checked';        // no-nag within this session
  const TS_KEY     = 'gbm_market_ts';      // timestamp for TTL
  const TTL_DAYS   = 90;                   // set to 0 to disable TTL
  let lastSubmitHandler = null; // shared submit fn used by "Check another ZIP"


  const preserveQH = () => (location.search || '') + (location.hash || '');
  const go = (url) => location.href = url.replace(/[#?]*$/, '') + preserveQH();
  const setCookie = (k, v, days = 7) => {
    const exp = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${k}=${v}; path=/; expires=${exp}; SameSite=Lax`;
  };

  // Backdrop appearance
const backdropTone = (SCRIPT.dataset.gbmBackdrop || 'dark').toLowerCase();
const BACKDROP_COLOR = backdropTone === 'white' ? 'rgba(255,255,255,0.68)' : 'rgba(17,17,17,0.5)';
const backdropBlurPx = Math.max(parseInt(SCRIPT.dataset.gbmBlur || '0', 10), 0);
const BACKDROP_FILTER = backdropBlurPx ? `blur(${backdropBlurPx}px)` : '';

function buildDestWithZip(baseUrl, mode) {
  try {
    var z = (localStorage.getItem('gbm_zip') || '').trim();
    var dest = new URL(baseUrl, window.location.origin);

    // Carry zip
    if (/^\d{5}$/.test(z)) dest.searchParams.set('gbm_zip', z);

    // Carry mode when provided
    if (mode === 'local' || mode === 'ship') dest.searchParams.set('gbm_mode', mode);

    // Preserve UTMs/hash without overwriting dest’s keys
    var cur = new URL(window.location.href);
    cur.searchParams.forEach((v, k) => {
      if (!dest.searchParams.has(k)) dest.searchParams.append(k, v);
    });
    if (!dest.hash && cur.hash) dest.hash = cur.hash;

    return dest.toString();
  } catch (e) {
    return baseUrl;
  }
}

function injectEmergencyStyles() {
  const id = 'gbm-gate-emergency-styles';
  if (document.getElementById(id)) return;
  const style = document.createElement('style');
  style.id = id;
style.textContent =
  ':root:root body #gbm-gate-backdrop{' +
    'background:' + BACKDROP_COLOR + '!important;' +
    'position:fixed!important;inset:0!important;z-index:2147483000!important;' +
    (BACKDROP_FILTER ? 'backdrop-filter:' + BACKDROP_FILTER + '!important;' : '') +
  '}' +
  ':root:root body #gbm-gate-backdrop.is-open{opacity:1!important;pointer-events:auto!important;}' +
  ':root:root body #gbm-gate-modal{position:fixed!important;inset:0!important;z-index:2147483001!important;display:grid!important;place-items:center!important;pointer-events:none!important;}' +
  ':root:root body #gbm-gate-modal .gbm-card{background:#fff!important;color:#111!important;border:1px solid rgba(0,0,0,.12)!important;border-radius:16px!important;box-shadow:0 30px 60px rgba(0,0,0,.18),0 12px 24px rgba(0,0,0,.12)!important;pointer-events:auto!important;}';
  document.head.appendChild(style);
}

// force important inline styles on an element
function forceStyles(el, rules){
  if (!el) return;
  for (const [prop, val] of Object.entries(rules)) {
    el.style.setProperty(prop, val, 'important');
  }
}

function gbmSetCookie(name, value, days) {
  try {
    var maxAge = days ? days*24*60*60 : 0; // seconds
    var parts = [
      name + '=' + encodeURIComponent(value),
      'Path=/',
      'SameSite=Lax'
    ];
    if (maxAge) parts.push('Max-Age=' + maxAge);
    if (location.protocol === 'https:') parts.push('Secure');
    document.cookie = parts.join('; ');
  } catch(e) {}
}
function gbmGetCookie(name) {
  try {
    return document.cookie.split('; ').reduce((acc, c) => {
      const [k, ...v] = c.split('=');
      return k === name ? decodeURIComponent(v.join('=')) : acc;
    }, '');
  } catch(e) { return ''; }
}
function gbmDelCookie(name) {
  try {
    document.cookie = name + '=; Path=/; Max-Age=0; SameSite=Lax';
  } catch(e) {}
}


  // --- Expire stored choice after TTL (optional) ---
  (function expireOldChoice(){
    if (!TTL_DAYS) return;
    const ts = parseInt(localStorage.getItem(TS_KEY) || '0', 10);
    if (!ts) return;
    const ageDays = (Date.now() - ts) / 864e5;
    if (ageDays > TTL_DAYS) {
      localStorage.removeItem(LS_MARKET);
      localStorage.removeItem(TS_KEY);
    }
  })();

  function setChoice(market){
    localStorage.setItem(LS_MARKET, market);
    localStorage.setItem(TS_KEY, Date.now().toString());
    sessionStorage.setItem(SS_CHECKED, '1');
  }

  // --- Path whitelist (SHIPPING site pages only) ---
  // Fires on EXACTLY these pages (with optional trailing slash) and allows extra segments for collections (filters/pagination)
  const PATHS_SHIP_EXACT = [
    /^\/pages\/order-now\/?$/i,
    /^\/pages\/how-it-works\/?$/i,
    /^\/pages\/frequently-asked-questions\/?$/i
  ];
  const PATHS_SHIP_PREFIX = [
    /^\/collections\/pre-built-batches(\/|$)/i,
    /^\/collections\/combined-products-for-redesign(\/|$)/i
  ];
  function onWhitelistedPath() {
    const p = location.pathname;
    if (PATHS_SHIP_EXACT.some(rx => rx.test(p))) return true;
    if (PATHS_SHIP_PREFIX.some(rx => rx.test(p))) return true;
    return false;
  }

  function getActiveModalObj() {
    // prefer the modalObj from main(), else fall back to the last one we injected
    return (window.__gbmModalObj /* set below */) || null;
  }


  // =========================
  // Modal presentation layer
  // =========================
  function lockScroll(lock) {
    if (lock) {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    } else {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }
  }

function injectModal() {
  injectEmergencyStyles(); // <— new

  // Backdrop
  let backdrop = document.getElementById('gbm-gate-backdrop');
  if (!backdrop) {
    backdrop = document.createElement('div');
    backdrop.id = 'gbm-gate-backdrop';
    document.body.appendChild(backdrop);
  }
  // Inline hardening for backdrop
// Inline hardening for backdrop
forceStyles(backdrop, {
  background: BACKDROP_COLOR,
  position: 'fixed',
  inset: '0',
  left: '0', top: '0', right: '0', bottom: '0',   // fallback in case 'inset' is overridden
  width: '100vw',
  height: '100vh',
  opacity: '0',                 // start hidden (will flip to 1 below)
  'pointer-events': 'none',     // start inert (will flip to auto below)
  'z-index': '2147483000',
  ...(BACKDROP_FILTER ? { 'backdrop-filter': BACKDROP_FILTER } : {})
});

  // Modal shell
  let modal = document.getElementById('gbm-gate-modal');
  if (!modal) {
    modal = document.createElement('div');
    modal.id = 'gbm-gate-modal';
    modal.innerHTML = `
      <div class="gbm-card" role="dialog" aria-modal="true" aria-labelledby="gbm-gate-title">
        <div class="gbm-card__header">
          <div id="gbm-gate-title" class="gbm-card__title">We're Growing!</div>
          <button class="gbm-card__close" id="gbm-gate-close" aria-label="Close">✕</button>
        </div>
        <div class="gbm-card__body" id="gbm-gate-body">
          <div class="gbm-card__lead"><strong>What’s your delivery ZIP Code?</strong> We’ll send you to the right ordering experience for your desired delivery location and remember it for next time.</div>
          <form id="zip-gate-form" class="gbm-form">
            <label for="zip-input" class="visually-hidden">ZIP</label>
            <input id="zip-input" class="gbm-input" inputmode="numeric" pattern="[0-9]{5}" maxlength="5" placeholder="ZIP code">
            <div class="gbm-actions">
              <button type="submit" class="gbm-btn gbm-btn--primary">Check ZIP</button>
              <button type="button" id="zip-gate-dismiss" class="gbm-btn gbm-btn--link">Not now</button>
            </div>
          </form>
          <div class="gbm-note">Menus, delivery options, and FAQs can vary by area. This helps us make sure you're seeing the right information for you!</div>
        </div>
      </div>
    `;
    document.body.appendChild(modal);
  }
  // Inline hardening for modal container
  forceStyles(modal, {
    position: 'fixed', inset: '0',
    display: 'grid', 'place-items': 'center',
    'pointer-events': 'none',
    'z-index': '2147483001'
  });

  const card = modal.querySelector('.gbm-card');
  forceStyles(card, {
    background: '#ffffff',
    color: '#111111',
    'border-radius': '16px'
  });

  // open animation + re-enforce one frame later (beats late overrides)
  requestAnimationFrame(() => {
    backdrop.classList.add('is-open');
    modal.classList.add('is-open');
forceStyles(backdrop, {
  background: BACKDROP_COLOR,
  opacity: '1',
  'pointer-events': 'auto',
  ...(BACKDROP_FILTER ? { 'backdrop-filter': BACKDROP_FILTER } : {})
});
    forceStyles(card, { background: '#ffffff' });
    lockScroll(true);
    modal.querySelector('#zip-input')?.focus({ preventScroll: true });
  });

  // re-enforce after a tick in case another script tweaks it
  setTimeout(() => {
forceStyles(backdrop, {
  background: BACKDROP_COLOR,
  opacity: '1',
  'pointer-events': 'auto',
  ...(BACKDROP_FILTER ? { 'backdrop-filter': BACKDROP_FILTER } : {})
});
    forceStyles(card, { background: '#ffffff' });
  }, 50);

  // After requestAnimationFrame:
forceStyles(backdrop, { background: BACKDROP_COLOR, ...(BACKDROP_FILTER ? { 'backdrop-filter': BACKDROP_FILTER } : {}) });

// After setTimeout re-enforce:
forceStyles(backdrop, { background: BACKDROP_COLOR, ...(BACKDROP_FILTER ? { 'backdrop-filter': BACKDROP_FILTER } : {}) });


  function closeModal() {
    backdrop.classList.remove('is-open');
    modal.classList.remove('is-open');
    lockScroll(false);
    setTimeout(() => { backdrop.remove(); modal.remove(); }, 200);
  }

  document.getElementById('gbm-gate-close')?.addEventListener('click', closeModal);
  backdrop.addEventListener('click', closeModal);
  document.addEventListener('keydown', function esc(e){
    if (e.key === 'Escape') { closeModal(); document.removeEventListener('keydown', esc); }
  });

  // Always stamp the active modal before returning
  const modalObj = { modal, closeModal };
  window.__gbmModalObj = modalObj;
  return modalObj;
}

function renderLocalFoundModal(mo) {
  const M = mo || window.__gbmModalObj;
  if (!M || !M.modal) { console.warn('[gbm] no active modal'); return; }
  const { modal, closeModal } = M; 
  const body = modal.querySelector('#gbm-gate-body');
  body.innerHTML = `
    <div class="gbm-success">
      <div class="gbm-card__title" style="text-align:center">You’re in our great Tri-Cities (TN/VA) region!</div>
      <div class="gbm-card__lead" style="text-align:center">You're best suited for our local, drive-up home delivery option that runs weekly in the Tri-Cities.</div>
      <div class="gbm-actions">
        <a id="zip-gate-go-local" class="gbm-btn gbm-btn--primary" href="#">Shop GBM in the Tri-Cities</a>
        <button id="zip-gate-stay" class="gbm-btn gbm-btn--link">Stay on Shipping</button>
        <button id="zip-gate-recheck" class="gbm-btn gbm-btn--link">Check another ZIP code</button>
      </div>
    </div>
  `;

  const goBtn   = body.querySelector('#zip-gate-go-local');
  const stayBtn = body.querySelector('#zip-gate-stay');
  const recheck = body.querySelector('#zip-gate-recheck');

  if (cfg.localUrl) { try { goBtn.setAttribute('href', buildDestWithZip(cfg.localUrl, 'local')); } catch(_) {} }
   else { goBtn.setAttribute('href', '#'); }

  goBtn.addEventListener('click', (e) => {
    e.preventDefault();
    setChoice('local');
    if (cfg.localUrl) location.href = goBtn.getAttribute('href');
    else closeModal();
  });

  stayBtn.addEventListener('click', () => { setChoice('ship'); closeModal(); });

  // ⬇️ New: return to the first screen
recheck.addEventListener('click', () => {
  renderZipPrompt(window.__gbmModalObj, lastSubmitHandler);
});
}

  
function renderShipConfirmModal(mo) {
  const M = mo || window.__gbmModalObj;
  if (!M || !M.modal) { console.warn('[gbm] no active modal'); return; }
  const { modal, closeModal } = M;
  const body = modal.querySelector('#gbm-gate-body');
  body.innerHTML = `
    <div class="gbm-success">
      <div class="gbm-card__lead">You’re in the right place! Carry on 🎉</div>
      <div class="gbm-actions">
        <button id="zip-gate-continue" class="gbm-btn gbm-btn--primary">Continue Shopping</button>
        <button id="zip-gate-recheck" class="gbm-btn gbm-btn--link">Check another ZIP code</button>
        <div class="gbm-note">This is not a commitment to ship to an address or ZIP code. Final delivery verification is done at checkout.</div>
      </div>
    </div>
  `;
  const cont = body.querySelector('#zip-gate-continue');
  cont.addEventListener('click', () => {
    setChoice('ship');   // remember for 90 days
    closeModal();
  });

body.querySelector('#zip-gate-recheck').addEventListener('click', () => {
  renderZipPrompt(window.__gbmModalObj, lastSubmitHandler);
});

}

function renderZipPrompt(mo, onSubmit) {
   onSubmit = (typeof onSubmit === 'function') ? onSubmit : (el) => {
    console.warn('[gbm] renderZipPrompt called without a submit handler');
  };
  if (mo) window.__gbmModalObj = mo;
  const { modal, openModal, closeModal } = mo || {};
  if (!modal) { console.warn('[gbm] no modal to render into'); return; }
  const body = modal.querySelector('#gbm-gate-body') || modal;
  body.innerHTML = `
    <div class="gbm-card__lead">
      <strong>What’s your delivery ZIP code?</strong> We’ll send you to the right ordering experience for your desired delivery location and remember it for next time.
    </div>
    <form id="zip-gate-form" class="gbm-form">
      <label for="zip-input" class="visually-hidden">ZIP</label>
      <input id="zip-input" class="gbm-input" inputmode="numeric" pattern="[0-9]{5}" maxlength="5" placeholder="ZIP code">
      <div class="gbm-actions">
        <button type="submit" class="gbm-btn gbm-btn--primary">Check ZIP</button>
        <button type="button" id="zip-gate-dismiss" class="gbm-btn gbm-btn--link">Not now</button>
      </div>
    </form>
    <div class="gbm-note">Menus, delivery options, and FAQs can vary by area. This helps us make sure you're seeing the right information for you!</div>
  `;

  const form       = body.querySelector('#zip-gate-form') || body.querySelector('form');
  const input      = body.querySelector('#zip-input') || body.querySelector('input[name*="zip" i], input[placeholder*="zip" i]');
  const primaryBtn = body.querySelector('.gbm-btn--primary, button[type="submit"]');
  const dismissBtn = body.querySelector('#zip-gate-dismiss');

  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      onSubmit && onSubmit(input);
    });
  }
  if (primaryBtn) {
    primaryBtn.addEventListener('click', (e) => {
      e.preventDefault();
      onSubmit && onSubmit(input);
    });
  }
if (dismissBtn) {
  dismissBtn.addEventListener('click', (e) => {
    e.preventDefault();
    try { sessionStorage.setItem(SS_CHECKED, '1'); } catch(_) {}
    closeModal();                 // from injectModal()
  });
}
  input?.focus({ preventScroll: true });
}


  // =========================
  // Main
  // =========================
async function main() {
  try {
    // 1) ZIP allowlist container (can be filled later by fetch)
    let LOCAL = new Set();

    // 2) Always resolve the active modal at click-time (not via a closed-over var)
    function getActiveModalObj() {
      return window.__gbmModalObj || null;
    }

    // 3) SINGLE shared submit handler (used by auto-open and header-open)
    lastSubmitHandler = function(inputEl) {
      const z = (inputEl.value || '').trim();
      if (!/^\d{5}$/.test(z)) { inputEl.focus(); return; }

      const isLocal = LOCAL.has(z);

      // Persist for 90d + mirror to LS so header chip hydrates fast
      try {
        setCookie('gbm_zip', z, 90);
        localStorage.setItem('gbm_zip', z);
      } catch (e) {}

      // Notify header chip immediately
      try {
        window.dispatchEvent(new CustomEvent('gbm:zipSelectionConfirmed', {
          detail: { zip: z, mode: isLocal ? 'local' : 'ship' }
        }));
        window.__gbmZipHandled = true;
      } catch (e) {}

      // Use the active modal (works for both auto-open and header-open)
      const mo = getActiveModalObj();

      // Prompt-local (test) flow vs. redirect (prod)
      if (cfg.mode === 'prompt-local') {
        if (isLocal) { renderLocalFoundModal(mo); }
        else         { renderShipConfirmModal(mo); }
        return;
      }

 if (isLocal && cfg.localUrl) {
   setChoice('local');
   location.href = buildDestWithZip(cfg.localUrl, 'local');
   return;
 }

if (!isLocal && cfg.shipUrl) { setChoice('ship');  return go(cfg.shipUrl); }

      sessionStorage.setItem(SS_CHECKED, '1');
      mo?.closeModal?.();
    };

    // 4) Fill LOCAL allowlist (handler will “see” the updated Set later)
    if (cfg.localMapUrl) {
      try {
        const res = await fetch(cfg.localMapUrl, { cache: 'no-store' });
        if (res.ok) {
          const arr = await res.json();
          if (Array.isArray(arr)) LOCAL = new Set(arr);
        }
      } catch(_) {}
    }

    // 6) ----- MANUAL OPEN from header chip: works on any page -----
window.addEventListener('gbm:openZipChecker', function(){
  const mo = injectModal();            // step 1 sets window.__gbmModalObj
  renderZipPrompt(mo, lastSubmitHandler);
  window.__gbmZipHandled = true;
});


{
  const params = new URLSearchParams(location.search);
  const urlGuess = (params.get('market') || '').toLowerCase(); // 'local' | 'ship'
  const cookieGuess = (document.cookie.split('; ').find(c => c.startsWith('gbm_guess=')) || '').split('=')[1];
  const inputEl = document.getElementById('zip-input');
  if ((urlGuess === 'local' || cookieGuess === 'local') && inputEl && !inputEl.value) {
    inputEl.placeholder = 'e.g., 379xx';
  }
}

// ---------- initial render: ONLY auto-open on whitelisted SHIPPING pages ----------
const urlParams = new URLSearchParams(location.search);
const hasGateParam = urlParams.has(cfg.enableParam || 'gate');

// Do we already have a ZIP? (cookie OR localStorage)
const hasZipCookie = !!gbmGetCookie('gbm_zip');
let hasZipLS = false;
try { hasZipLS = !!localStorage.getItem('gbm_zip'); } catch(e) {}
const hasZip = hasZipCookie || hasZipLS;

const recentlyChecked = !!sessionStorage.getItem(SS_CHECKED);

if (onWhitelistedPath() && (hasGateParam || (!hasZip && !recentlyChecked))) {
  const mo = injectModal();                          // ← create/open modal now
  renderZipPrompt(mo, lastSubmitHandler);
}

      // Team helper: visit once with ?gate=1&team=1 to set cookie for all pages
      const p = new URLSearchParams(location.search);
      if (p.has('team')) setCookie('gbm_gate_test','1');

    } catch (e) {
      console.warn('[GBM Gate]', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', main);
  } else {
    main();
  }


})();
